import { invitationActionTypes } from './invitation.types';

// VERIFY
export const invitationVerifyRequest = (token) => ({
    type: invitationActionTypes.INVITATION_VERIFY_REQUEST,
    payload: { token },
});
export const invitationVerifySuccess = (data) => ({
    type: invitationActionTypes.INVITATION_VERIFY_SUCCESS,
    payload: data,
});
export const invitationVerifyFailure = (error) => ({
    type: invitationActionTypes.INVITATION_VERIFY_FAILURE,
    payload: error,
});

// ACCEPT
export const invitationAcceptRequest = (token) => ({
    type: invitationActionTypes.INVITATION_ACCEPT_REQUEST,
    payload: { token },
});
export const invitationAcceptSuccess = () => ({
    type: invitationActionTypes.INVITATION_ACCEPT_SUCCESS,
});
export const invitationAcceptFailure = (error) => ({
    type: invitationActionTypes.INVITATION_ACCEPT_FAILURE,
    payload: error,
});

// RESET
export const invitationReset = () => ({
    type: invitationActionTypes.INVITATION_RESET,
});
